<template>
	<div ref="content" class="content background2">
		<div ref="search">
			<SearchList ref="searchContent" :searchList="searchList"></SearchList>
		</div>
		<div ref="btnList">
			<BtnList ref="btn" :btnList="btnList"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{'padding-top':paddingTop}">
			<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
				@parentMethod="getInfo"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	import CommonJs from "@/assets/js/common/common.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				levelList: [],
				paddingTop: 0,
				searchList: [{
					searchLabel: '角色名称',
					searchValue: '',
					searchType: 0,
					searchWidth: '25%',
					searchBr: false,
					column: 'roleName',
				}, ],
				btnList: [],
				tableList: [{
					column: 'roleName',
					title: '角色名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'remark',
					title: '角色描述',
					headerAlign: 'center',
					align: 'center',
					width: '60%'
				}, {
					column: 'roleCode',
					title: '角色编码',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}],
				tableData: [],
				menuList: [],
				tableInfo: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			}
		},
		methods: {
			queryArea() {},
			getRoleList(param) {
				User.getRoleList(param).then((response) => {
					const data = response.data;
					this.pageCount = data.data.total;
					this.pageNo = data.data.current;
					this.$refs['pageModel'].setCurrent(this.pageNo);
					this.tableData = data.data.records;
				}).catch((response) => {
					console.log(response)
				})
			},
			search(param) {
				var dataParam = this.$refs.searchContent.getSearchParam();
				var newParam = Object.assign(param, dataParam);
				this.getRoleList(newParam);
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - (this.$refs.search.clientHeight + this.$refs.btnList
					.clientHeight +
					20) - 60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			getInfo(info) {
				this.tableInfo = info;
			}
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;

			const $this = this;
			if (this.menuList.indexOf("CD_621") != -1) {
				this.btnList.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '角色名称',
							value: '',
							column: 'roleName',
							columnType: 0,
							placeholder: '请输入角色名称',
						},
						{
							columnLabel: '角色描述',
							value: '',
							column: 'remark',
							columnType: 0,
							placeholder: '请输入角色描述',
						},
						{
							columnLabel: '角色编码',
							value: '',
							column: 'roleCode',
							columnType: 0,
							placeholder: '请输入角色编码',
						},
						{
							columnLabel: '菜单权限',
							value: [],
							column: 'menus',
							columnType: 9,
							placeholder: '请输入角色描述',
						}
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							item.value = '';
						})
					},
					btnFun: function(tip, info) {
						let list = [];
						info.menus.forEach((item, index) => {
							if (item != null) {
								list.push(item);
							}
						})
						info.menus = list;
						if (info.roleName == '') {
							$this.utils.tipsAlert('请填写角色名称');
							return;
						}
						if (info.remark == '') {
							$this.utils.tipsAlert('请填写角色描述');
							return;
						}
						if (info.roleCode === '') {
							$this.utils.tipsAlert('请填写角色编码');
							return;
						}
						User.addUser(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.saveAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								$this.btnList[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}

			if (this.menuList.indexOf("CD_622") != -1) {
				this.btnList.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnLabel: '角色名称',
							value: '',
							column: 'roleName',
							columnType: 0,
							placeholder: '请输入角色名称',
						},
						{
							columnLabel: '角色描述',
							value: '',
							column: 'remark',
							columnType: 0,
							placeholder: '请输入角色描述',
						},
						{
							columnLabel: '角色编码',
							value: '',
							column: 'roleCode',
							columnType: 0,
							placeholder: '请输入角色编码',
						},
						{
							columnLabel: '菜单权限',
							value: [],
							column: 'menus',
							columnType: 9,
							placeholder: '请输入角色描述',
						}
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							let roleCodeMes = {
								roleCode: $this.tableInfo.roleCode
							};
							let menuListArr = [];
							User.getMenusByRoleLevel(roleCodeMes).then((response) => {
								const data = response.data;
								if (data.code == 1) {
									menuListArr = data.data;
									tip(menuListArr);
								} else {
									$this.utils.tipsAlert(data.message);
								}
							}).catch((response) => {
								console.log(response)
							})
							$this.btnList[1].columnList.forEach(function(item, index) {
								if (item.column == "menus") {
									item.value = menuListArr
								} else {
									item.value = $this.tableInfo[item.column];
								}
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						info.roleId = $this.tableInfo.roleId;
						let list = [];
						info.menus.forEach((item, index) => {
							if (item != null) {
								list.push(item);
							}
						})
						info.menus = list;
						if (info.roleName == '') {
							$this.utils.tipsAlert('请填写角色名称');
							return;
						}
						if (info.remark == '') {
							$this.utils.tipsAlert('请填写角色描述');
							return;
						}
						if (info.roleCode === '') {
							$this.utils.tipsAlert('请选择角色编码');
							return;
						}
						User.updataUser(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.editAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}

			if (this.menuList.indexOf("CD_623") != -1) {
				this.btnList.push({
					btnLabel: '删除',
					btnType: 5,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this.$confirm('是否删除这个角色?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								var info = [$this.tableInfo.roleId]
								User.delUser(info).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize
									});
								}).catch((response) => {
									console.log(response)
								})
							});
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					}
				});
			}

			this.btnList.push({
				btnLabel: '查询',
				btnType: 3,
				btnPosition: 'right',
				btnFun: function() {
					$this.search({
						pageNo: 1,
						pageSize: $this.pageSize
					});
				},
			});
		},
		mounted() {
			this.paddingTop = (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight + 20) + 'px';
			this.getWindowHeight();
			window.onresize = () => {
				this.getWindowHeight();
				this.$refs.list.getHeight();
			}
			this.menuList = this.$store.getters.getMenuPermission;
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/system/role.vue